import React from "react";
import property from "../property.json";

function Profile(){
  return(
    <div className="about">
        <h3 className="title2">Profile:</h3>
        <p>
          {property.profile}
        </p>
      </div>
  )
}

export default Profile;